import React from 'react';
import PropTypes from 'prop-types';
import connectToStores from 'alt-utils/lib/connectToStores';
import {EulaStore} from '../../stores';
import {Footer} from '../../components';

/**
 * Eula View
 */
@connectToStores
export default class EulaView extends React.PureComponent {
    static propTypes = {
        eulaStore: PropTypes.object
    };

    static getStores() {
        return [EulaStore];
    }

    static getPropsFromStores() {
        return {
            eulaStore: EulaStore.getState()
        };
    }

    render() {
        const {eulaStore: {eulaContent}} = this.props;
        let eulaContainer;
        if (eulaContent) {
            eulaContainer = (
                <div className="odin-site-block eula-container">
                    <div className="site-block-header">
                        <h1 className="site-block-title eula-title">
                            {eulaContent && eulaContent.title}
                        </h1>
                    </div>
                    <div className="site-block-body">
                        <div className="site-block-body-text eula-text" dangerouslySetInnerHTML={{__html: eulaContent && eulaContent.body}} />
                    </div>
                </div>
            );
        }
        return (
            <div className="eula-view-container">
                <div className="light-bg">
                    <div id="eulaContainer" className="container eula">
                        {eulaContainer}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
